module.exports = __webpack_public_path__ + "static/media/silverball.b73f7a2b.png";